// Test IDs for QA / Playwright
export const NAV = {
  logo: "nav-logo",
  link: (id) => `nav-link-${id}`,
  ctaSignup: "nav-cta-signup",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  title: "hero-title",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  liveWidget: "hero-live-widget",
};

export const HOME = {
  emergentLink: "emergent-link",
  servicesSection: "section-services",
  publishersSection: "section-publishers",
  advertisersSection: "section-advertisers",
  mangaSection: "section-manga",
  partnersSection: "section-partners",
  aboutSection: "section-about",
  testimonialsSection: "section-testimonials",
  pricingSection: "section-pricing",
  faqSection: "section-faq",
  newsletterInput: "newsletter-input",
  newsletterSubmit: "newsletter-submit",
  scheduleDemoBtn: "schedule-demo-btn",
};

export const CHAT = {
  bubble: "chat-bubble",
  panel: "chat-panel",
  input: "chat-input",
  send: "chat-send",
  close: "chat-close",
};

export const FAQ = {
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  root: "footer-root",
  link: (id) => `footer-link-${id}`,
};
